module.exports = __webpack_public_path__ + "img/yiyao_shouyansuo_suoluetu.f1c0e522.png";